export default "__VITE_ASSET__EHY87zqP__"